import React, { ReactNode } from "react";
import styled from "styled-components";
import Legend from "@charty/legend";
import { Item } from "@charty/legend/item/model";
import Tooltip from "@charty/tooltip/histogram";
import { Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { useTotal } from "./data";

export interface LegendProps {
  series: Item[];
  setHovered: (uid: string) => void;
  onClickLegend: (uid: Item["id"]) => void;
  tooltip?: (serie: Item, total: number) => ReactNode;
  total?: number;
  range: Range;
  locale: Locale;
  disableAnimation?: boolean;
  displayVolumes?: boolean;
}

const StyledLegend = styled(Legend)`
  margin-bottom: 12px;
`;

const StackedBarChartLegend = React.memo(
  ({
    series,
    setHovered,
    locale,
    onClickLegend,
    tooltip,
    total,
    range,
    disableAnimation,
    displayVolumes,
  }: LegendProps) => {
    const _total = useTotal(total, series);

    return (
      <StyledLegend
        items={series}
        disableAnimation={disableAnimation}
        displayVolumes={displayVolumes}
        setHovered={setHovered}
        align="left"
        locale={locale}
        onClickSerie={onClickLegend}
        tooltip={
          tooltip
            ? (serie) => tooltip(serie, _total)
            : (serie) => (
                <Tooltip
                  count={serie.count}
                  label={serie.label}
                  color={serie.color}
                  locale={locale}
                  range={range}
                  total={_total}
                />
              )
        }
      />
    );
  }
);

export default StackedBarChartLegend;
